/*!
 * secp256k1.js - secp256k1 for bcrypto
 * Copyright (c) 2014-2015, Fedor Indutny (MIT License)
 * Copyright (c) 2014-2017, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcrypto
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ECDSA = require('./ecdsa');

var SHA256 = require('../sha256');

var pre = require('./precomputed/secp256k1.json');
/**
 * Secp256k1
 */


var Secp256k1 = /*#__PURE__*/function (_ECDSA) {
  _inherits(Secp256k1, _ECDSA);

  var _super = _createSuper(Secp256k1);

  function Secp256k1() {
    _classCallCheck(this, Secp256k1);

    return _super.call(this, 'SECP256K1', SHA256, pre);
  }

  _createClass(Secp256k1, [{
    key: "schnorrSign",
    value: function schnorrSign(msg, key) {
      return this.schnorr.sign(msg, key);
    }
  }, {
    key: "schnorrVerify",
    value: function schnorrVerify(msg, sig, key) {
      return this.schnorr.verify(msg, sig, key);
    }
  }, {
    key: "schnorrBatchVerify",
    value: function schnorrBatchVerify(batch) {
      return this.schnorr.batchVerify(batch);
    }
  }]);

  return Secp256k1;
}(ECDSA);
/*
 * Expose
 */


module.exports = new Secp256k1();